<template>
  <div>
    <div class="row mb-3">
      <div class="col-md-6">
        <list-subject-types
          class="w-100"
          autocomplete
          label="Destinos"
          name="subjectType"
          data-cy="subject-type"
          v-model="subjectForm.subjectType"
          v-validate="'required'"
          :danger="errors.has('step-2-part-2.subjectType')"
          :danger-text="errors.first('step-2-part-2.subjectType')"
          ref="subjectType"
        />
      </div>
      <div class="col-md-6" v-if="subjectForm.subjectType === 'docDigital'">
        <list-institutions-doc-digital
          class="w-100"
          autocomplete
          label="Lista de Instituciones DocDigital"
          name="subjectTypeDigitalDoc"
          v-model="subjectForm.subjectTypeDigitalDoc"
          :parent-value="subjectForm.subject"
          v-validate="{ required: subjectForm.subjectType === 'docDigital'}"
          :danger="errors.has('step-2-part-2.subjectTypeDigitalDoc')"
          :danger-text="errors.first('step-2-part-2.subjectTypeDigitalDoc')"
          ref="subjectTypeDigitalDoc"
          data-cy="subjectTypeDigitalDoc"
          @full-input="setSubject"
        />
      </div>
      <div :class="{
        'col-12': subjectForm.subjectType === 'docDigital',
        'col-md-6': subjectForm.subjectType !== 'docDigital',
      }">
        <list-offices
          v-if="
            !isInput.includes(subjectForm.subjectType)
              && subjectForm.subjectType === 'oficinas'
          "
          class="w-100"
          autocomplete
          label="Oficina"
          name="subject"
          data-cy="subject"
          v-model="subjectForm.subject"
          :danger="errors.has('step-2-part-2.subject')"
          :danger-text="errors.first('step-2-part-2.subject')"
          v-validate="{ required:  !isInput.includes(subjectForm.subjectType)
            && subjectForm.subjectType === 'oficinas' }"
          ref="subject"
          key="subject-select"
        />
        <list-groups
          v-if="
            !isInput.includes(subjectForm.subjectType)
              && subjectForm.subjectType === 'unidades'
          "
          class="w-100"
          autocomplete
          label="Unidad"
          name="subject"
          data-cy="subject"
          :typeList="1"
          v-model="subjectForm.subject"
          :danger="errors.has('step-2-part-2.subject')"
          :danger-text="errors.first('step-2-part-2.subject')"
          v-validate="{ required:  !isInput.includes(subjectForm.subjectType)
            && subjectForm.subjectType === 'unidades' }"
          ref="subject"
          key="subject-select"
        />
        <list-subjects
          v-if="
            !isInput.includes(subjectForm.subjectType)
              && subjectForm.subjectType !== 'usuarios'
              && subjectForm.subjectType !== 'oficinas'
              && subjectForm.subjectType !== 'unidades'
          "
          class="w-100"
          autocomplete
          label="Lista de Destino"
          name="subject"
          data-cy="subject"
          v-model="subjectForm.subject"
          :parent-value="subjectForm.subjectType"
          v-validate="{
            required: !isInput.includes(subjectForm.subjectType)
              && subjectForm.subjectType !== 'usuarios'
          }"
          :disabled="!subjectForm.subjectType || this.institutionsDocDigitalState.loading"
          :danger="errors.has('step-2-part-2.subject')"
          :danger-text="errors.first('step-2-part-2.subject')"
          ref="subject"
          key="subject-select"
          @input="clearEntities"
        />
        <list-user
          v-if="
            !isInput.includes(subjectForm.subjectType)
              && subjectForm.subjectType === 'usuarios'
          "
          class="w-100"
          withFilters
          rolId="7441a75e-80b9-486a-8595-34c487a56dd9"
          autocomplete
          label="Lista de Destino"
          name="subject"
          data-cy="subject"
          v-model="subjectForm.subject"
          v-validate="{
            required: !isInput.includes(subjectForm.subjectType)
              && subjectForm.subjectType === 'usuarios'
          }"
          :disabled="!subjectForm.subjectType"
          :danger="errors.has('step-2-part-2.subject')"
          :danger-text="errors.first('step-2-part-2.subject')"
          ref="subject"
          key="subject-select"
          :filter-me-user="filterMe"
        />
        <vs-input
          v-if="isInput.includes(subjectForm.subjectType)"
          class="w-100"
          label="Ingrese un nombre"
          name="subject"
          data-cy="subject"
          v-model="subjectForm.subject"
          v-validate="{ required: isInput.includes(subjectForm.subjectType) }"
          :danger="errors.has('step-2-part-2.subject')"
          :danger-text="errors.first('step-2-part-2.subject')"
          key="subject-input"
        />
      </div>
    </div>
    <div
      class="row mb-3"
      v-if="emailRequired.includes(subjectForm.subjectType)"
    >
      <div class="col-12">
        <vs-input
          class="w-100"
          label="Correo Electrónico Persona Destinatario"
          name="subjectEmail"
          data-cy="subjectEmail"
          v-model="subjectForm.subjectEmail"
          v-validate="{
              required: emailRequired.includes(subjectForm.subjectType)
              ,
              email: true
            }"
          :danger="errors.has('step-2-part-2.subjectEmail')"
          :danger-text="errors.first('step-2-part-2.subjectEmail')"
        />
      </div>
    </div>
  <div
    class="row mb-3"
    v-if="subjectForm.subjectType === 'usuarios' && !isConvention"
  >
    <div class="col-6">
      <vs-select
        autocomplete
        class="w-100 con-select autocompletex"
        label="Seleccione tipo de providencia"
        v-model="subjectForm.providence"
        name="providence"
        data-cy="providence"
        v-validate="{
          required: needProvidence
        }"
        data-vv-as="providencia"
        :danger="errors.has('step-2-part-2.providence')"
        :danger-text="errors.first('step-2-part-2.providence')"
      >
        <vs-select-item
          :value="providenceTypes.KNOWLEDGE"
          text="Conocimiento"
        />
        <vs-select-item
          :value="providenceTypes.MANAGEMENT"
          text="Para gestión"
        />
        <vs-select-item
          v-if="forConvention"
          :value="providenceTypes.PARTICIPANT"
          text="Visto bueno"
        />
      </vs-select>
    </div>
    <div
      class="col-6"
      v-if="!isAguasAndinas"
    >
      <label>Fecha Vencimiento</label>
      <b-form-datepicker
        locale="es"
        :min="minDate"
        placeholder="Fecha vencimiento"
        name="providenceExpiration"
        data-cy="providenceExpiration"
        v-model="subjectForm.providenceExpiration"
        label-help="Puede usar las flechas del teclado y espacio"
      />
    </div>
    <div
        class="col-6"
        v-if="isAguasAndinas"
    >
      <label>Fecha Vencimiento</label>
      <b-form-datepicker
        today-button
        reset-button
        close-button
        v-bind="labels[locale] || {}"
        :min="minDate"
        :max="maxDate"
        :show-decade-nav="false"
        :hide-header="false"
        placeholder="Fecha vencimiento"
        name="providenceExpiration"
        data-cy="providenceExpiration"
        v-validate="{
          required: needProvidence
        }"
        data-vv-as="fecha vencimiento"
        :state="errors.has('step-2-part-2.providenceExpiration') ? false : null"
        v-model="subjectForm.providenceExpiration"
      />
      <b-form-invalid-feedback>
        {{ errors.first('step-2-part-2.providenceExpiration') }}
      </b-form-invalid-feedback>
    </div>
  </div>
  <div class="row mb-3">
    <div class="col-12 d-flex align-items-end justify-content-end">
      <div v-if="error.message !== ''" class="con-text-validation span-text-validation-danger
         vs-input--text-validation-span v-enter-to text-right"
         style="height: 32px;">
        <span class="span-text-validation">
          {{error.message}}
        </span>
      </div>
    </div>
    <div class="col-12 d-flex align-items-end justify-content-end">
      <b-button
        data-cy="add-recipient-button"
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        variant="primary"
        v-on:click="addSubject()"
      >
        Agregar Destinatario
      </b-button>
    </div>
  </div>
  </div>
</template>

<script>
import Ripple from 'vue-ripple-directive';
import { mapGetters } from 'vuex';

import ListSubjects from '@/febos/chile/lists/components/ListSubjects';
import ListInstitutionsDocDigital from '@/febos/chile/lists/components/ListInstitutionsDocDigital';
import ListSubjectTypes from '@/febos/chile/lists/components/ListSubjectTypes';
import ListUser from '@/febos/chile/lists/components/ListUser';
import ListOffices from '@/febos/chile/lists/components/ListOffices';
import ListGroups from '@/febos/chile/lists/components/ListGroups';
import ProvidencesTypes from '@/febos/chile/dnt/mixins/ProvidencesTypes';

export default {
  components: {
    ListSubjects,
    ListSubjectTypes,
    ListInstitutionsDocDigital,
    ListUser,
    ListOffices,
    ListGroups
  },
  directives: {
    Ripple
  },
  data() {
    return {
      locale: 'es',
      error: {
        message: ''
      },
      labels: {
        es: {
          labelPrevDecade: 'Década anterior',
          labelPrevYear: 'Año anterior',
          labelPrevMonth: 'Mes anterior',
          labelCurrentMonth: 'Mes actual',
          labelNextMonth: 'Mes siguiente',
          labelNextYear: 'Año siguiente',
          labelNextDecade: 'Década siguiente',
          labelToday: 'Hoy',
          labelSelected: 'Fecha seleccionada',
          labelNoDateSelected: 'Sin fecha seleccionada',
          labelCalendar: 'Calendario',
          labelNav: 'Navegación calendario',
          labelHelp: 'Use las teclas del cursor para navegar por las fechas del calendario',
          labelReset: 'Borrar',
          'label-today-button': 'Hoy',
          'label-reset-button': 'Borrar',
          'label-close-button': 'Cerrar'
        }
      },
      minDate: this.$moment().format('YYYY-MM-DD'),
      providenceTypes: ProvidencesTypes,
      emailRequired: ['personas', 'empresas', 'ministerios', 'personasJuridicas', 'organismoEstado'],
      isInput: ['personas', 'empresas', 'personasJuridicas', 'organismoEstado'],
      subjectForm: {
        subjectType: '',
        providence: '',
        providenceExpiration: '',
        subject: '',
        subjectTypeDigitalDoc: '',
        subjectEmail: '',
      },
      subjectsSelected: []
    };
  },
  computed: {
    ...mapGetters('Dnts', ['participants']),
    ...mapGetters('Empresas', ['company']),
    ...mapGetters('List', [
      'institutionsDocDigitalState'
    ]),
    isConvention() {
      return this.company.iut === '60100003-2';
    },
    isAguasAndinas() {
      return this.company.iut === '61808000-5';
    },
    maxDate() {
      return this.dateLimit;
    }
  },
  props: {
    docTypeSelected: { type: Object, default: () => {} },
    forConvention: {},
    needProvidence: Boolean,
    dateLimit: { type: String, default: undefined },
    filterMe: { type: Boolean, default: false }
  },
  methods: {
    clearEntities() {
      if (this.subjectForm.subjectTypeDigitalDoc) {
        this.subjectForm.subjectTypeDigitalDoc = '';
      }
    },
    setSubject(event) {
      this.subjectForm.subject = event?.order.toString() || '';
    },
    async validateForm(scope) {
      let result = await this.$validator.validateAll(scope);

      if (this.subjectForm.subjectType === 'docDigital' && (!this.docTypeSelected || !this.docTypeSelected.extra.idDocDigital)) {
        this.error.message = 'El tipo de documento seleccionado no esta configurado para ser enviado a DocDigital';
        result = false;
      }
      return !!result;
    },
    async addSubject() {
      const isValid = await this.validateForm('step-2-part-2');

      if (!isValid) {
        return;
      }

      const subjectType = this.$refs.subjectType.getOption();
      const subject = this.isInput.includes(this.subjectForm.subjectType)
        ? {
          label: this.subjectForm.subject,
          value: this.subjectForm.subject,
          id: this.subjectForm.subject
        }
        : this.$refs.subject.getOption();

      const subjectTypeDigitalDoc = this.$refs.subjectTypeDigitalDoc
        ? this.$refs.subjectTypeDigitalDoc.getOption()
        : {};

      const row = {
        subjectType,
        subject,
        subjectTypeDigitalDoc,
        subjectEmail: this.subjectForm.subjectEmail,
        providence: this.subjectForm.providence,
        providenceExpiration: this.subjectForm.providenceExpiration
      };
      this.$emit('add-subject', row);
      this.subjectForm.subject = '';
      this.subjectForm.providenceExpiration = '';
      this.subjectForm.providence = '';
      this.subjectForm.subjectTypeDigitalDoc = '';
      this.subjectForm.subjectEmail = '';
      await this.$validator.reset();
    }
  }
};
</script>
<style>

</style>
